interface ParallaxStripProps {
  imageUrl: string;
  alt: string;
}

export default function ParallaxStrip({ imageUrl, alt }: ParallaxStripProps) {
  return (
    <>
      {/* Mobile: full-width letterbox image, cinematic aspect, scrolls normally */}
      <img
        src={imageUrl}
        alt={alt}
        className="md:hidden w-full aspect-[21/9] object-cover object-center block"
      />
      {/* Desktop: fixed parallax background */}
      <div className="hidden md:block relative h-[16vh] overflow-hidden">
        <div
          className="absolute inset-0 bg-no-repeat bg-center bg-fixed bg-cover"
          style={{ backgroundImage: `url(${imageUrl})` }}
          role="img"
          aria-label={alt}
        />
        <div className="absolute inset-0 bg-black/15" />
      </div>
    </>
  );
}